const ricambi = {
    state: {
        component: 'Index',
        edit: false,
        all: []
    },
    mutations: {
        CHANGE_RICAMBI_COMPONENT(state, payload) {
            state.component = payload
        },
        CHANGE_RICAMBI_EDIT(state, payload) {
            state.edit = payload
        }
    },
    getters: {
        getRicambiComponent: state => state.component,
        getRicambiEdit: state => state.edit
    }
}

export default ricambi